import React from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";

import CalendarBox from "../../../../components/calendar-box/calendar-box";
import GuideLine from "../../../../components/guide-line";
import MainButton from "../../../../components/main-button";
import DicotomicButton from "../../../../components/dicotomic-button";
import PostalCode from "./postal-code/postal-code";
import HealthInsuredItem from "../../../../components/health-insured-item/health-insured-item";
import ImportButton from "../../../../components/insureds-import-button/import-button";
import ExportInsuredsButton from "../../../../components/insureds-export-button/export-button";
import { ErrorModalContainer } from "../../../../components/error-modal/error-modal-style";
import { images } from "../../../../assets";
import { PymesInsuredContainer } from "./salud-pymes-insured-style";

import { withPolicy } from "../../../../context/mixin/with-policy";
import { withCoverages } from "../../../../context/mixin/with-coverages";
import { withGeneral } from "../../../../context/mixin/with-general";
import { IHealthCoverage, STORAGE_KEY } from "../../../../constants/health";
import { FLOW_AREA } from "../../../../constants/flow";

import SaludPymesServices from "../../../../services/SaludPymesServices";
import { formatInsuredsCsv } from "./salud-pymes-insured-helpers";
import { validateAgeInsureds, validateSimulationInsureds } from "./salud-pymes-insured-validations";
import { calcAge } from "../../../../utils/utility";
import { getDayMonthYear } from "../../../../utils/time";
import { deepGet } from "../../../../utils/utility";
import { formatCoveragesHealth } from "../../../../utils/healthFormatData";
import {
  genderOptions,
  validateSimulationFieldHealth,
} from "../../../../utils/validation";
import {
  isCapitalInRangeHealthByCoverage,
  isOutOfCoverageAgeRange,
} from "../../../../utils/coverages";
import {
  Coverage,
  InsuredData,
  InsuredProps,
  InsuredState,
  Valid,
} from "./salud-pymes-insured-types";

class PymesInsured extends React.Component<InsuredProps, InsuredState> {
  constructor(props: InsuredProps) {
    super(props);
    let pymesSimulationData;
    if (localStorage.getItem(STORAGE_KEY.sKey)) {
      pymesSimulationData = JSON.parse(String(localStorage.getItem(STORAGE_KEY.sKey)));
    }

    this.state = {
      birthDate: "",
      coverages: [],
      pymesSimulationData: pymesSimulationData,
      insuredData: pymesSimulationData.insuredData ? pymesSimulationData.insuredData : [],
      mediatorData: pymesSimulationData.mediatorData,
      postalCode: "",
      valid: {
        postalCode: {
          validated: false,
          errorCode: "",
        },
        gender: {
          validated: false,
          errorCode: "",
        },
        birthDate: {
          validated: false,
          errorCode: "",
        },
      },
      gender: "",
      showLeftSearchBoxModal: false,
      indexInsured: 0,
      serverError: false,
      modalErrorText: "",
    };
  }

  async getCoverages() {
    const { setLoading, policy, coverages } = this.props;
    const productType: string = policy.product.products_coverageName;

    if (coverages && coverages[productType]) {
      this.setState({
        coverages: formatCoveragesHealth(coverages[productType], FLOW_AREA.SIMULACION),
      });
    } else {
      const resCoverages = await SaludPymesServices.getCoveragesFromDB(
        setLoading,
        true,
        productType
      ).catch((error) => {
        this.setState({
          serverError: true,
          modalErrorText: `Se ha producido un error. Vuelva a intentarlo más tarde.`,
        });
        throw error.statusText;
      });
      if (resCoverages !== undefined) {
        const cov = formatCoveragesHealth(resCoverages, FLOW_AREA.SIMULACION);
        this.setState({ coverages: cov });
      }
    }
  }

  componentDidMount = async () => {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 100);

    let { policy } = this.props;
    if (Object.keys(policy.product).length !== 0) {
      this.getCoverages();
    }
  };

  componentDidUpdate(prevProps: InsuredProps, prevState: InsuredState) {
    let { policy } = this.props;

    if (
      Object.keys(prevProps.policy.product).length === 0 &&
      Object.keys(policy.product).length !== 0
    ) {
      this.getCoverages();
    }
  }

  toValidate = async () => {
    const { history } = this.props;
    const { coverages } = this.state;
    const coveragesGroupRequired = new Set(
      coverages.filter((coverage) => coverage.groupRequired).map((coverage) => coverage.groupName)
    );

    const state = {
      insuredData: this.state.insuredData,
      mediatorData: this.state.mediatorData,
    };
    let { insuredData } = this.state;
    const { pymesSimulationData } = this.state;
    let error: boolean = false;

    insuredData.forEach((insured: InsuredData) => {
      let hasRequiredCoverage = false;
      if (coveragesGroupRequired) {
        coveragesGroupRequired.forEach((coverageGroupName) => {
          hasRequiredCoverage = !!insured.coverages.find(
            (coverage) => coverage.groupName === coverageGroupName && coverage.checked
          );
          if (!hasRequiredCoverage) {
            error = true;
          }
        });
      }

      insured.coverages.forEach((coverage: Coverage) => {
        if (coverage.checked && coverage.capitales) {
          if (coverage.capitalValue === "" || coverage.capitalValue === undefined) {
            coverage.errorCode = "required";
            error = true;
          } else {
            const rangeError = isCapitalInRangeHealthByCoverage(coverage as IHealthCoverage);

            if (rangeError !== "") {
              coverage.errorCode = rangeError;
              error = true;
            } else {
              coverage.errorCode = "";
            }
          }
        }
        if (!hasRequiredCoverage && coverage.firstGroupItem) {
          coverage.errorCode = "one-required";
        }
      });
    });

    if (!error) {
      if (pymesSimulationData) {
        pymesSimulationData.insuredData = this.state.insuredData;
        localStorage.setItem(STORAGE_KEY.sKey, JSON.stringify(pymesSimulationData));
      } else {
        localStorage.setItem(
          STORAGE_KEY.sKey,
          JSON.stringify({ insuredData: this.state.insuredData })
        );
      }

      history.replace({ state: state });
      history.push("/simulacion/nueva/salud-pymes/precios");
    }
    this.setState({ insuredData });
  };

  handleOnChangePostalCode = ({ valid, value }: { valid: Valid; value?: string }) => {
    this.setState((prev) => ({
      valid,
      postalCode: value ? value : prev.postalCode,
    }));
  };

  handleOnChangeBirthData = (value: string) => {
    const { valid } = this.state;
    const isRequiredField = true;
    valid.birthDate = validateSimulationFieldHealth(value, "birthDate", true, isRequiredField);
    this.setState({ birthDate: value, valid: valid });
  };

  handleOnChangeGender(value: string) {
    this.setState({ gender: value });
  }

  handleAddInsured = () => {
    const { postalCode, birthDate, valid, coverages, gender, insuredData, serverError } =
      this.state;
    valid.birthDate.validated = false;
    valid.postalCode.validated = false;

    insuredData.forEach((insured) => {
      insured.checked = false;
    });

    const newInsuredData = JSON.parse(JSON.stringify(insuredData));
    const { error } = validateAgeInsureds(birthDate, coverages, serverError);
    if (error && !serverError) {
      this.setState({
        serverError: true,
        modalErrorText:
          "El asegurado excede de la edad máxima permitida para alguna de las coberturas requeridas.",
      });
      return;
    }

    newInsuredData.push({
      birthDate,
      coverages: JSON.parse(JSON.stringify(coverages)),
      address: { postalCode },
      ...(gender ? { gender: gender } : {}),
      checked: true,
    });

    this.setState({
      birthDate: "",
      insuredData: newInsuredData,
      postalCode: "",
      gender: "",
    });
  };

  handleRemoveInsured = (id: number) => {
    let insuredData = this.state.insuredData;
    insuredData.splice(id, 1);
    this.setState({ insuredData }, () => {
      let pymesSimulationData;
      if (localStorage.getItem(STORAGE_KEY.sKey)) {
        pymesSimulationData = JSON.parse(String(localStorage.getItem(STORAGE_KEY.sKey)));
      }
      if (pymesSimulationData) {
        pymesSimulationData.insuredData = this.state.insuredData;
        localStorage.setItem(STORAGE_KEY.sKey, JSON.stringify(pymesSimulationData));
      }
    });
  };

  onChangeOption = (insured: number, age: number, coverage: Coverage, value: boolean) => {
    if (coverage.required || isOutOfCoverageAgeRange(age, coverage.edadMin, coverage.edadMax))
      return false;

    const { insuredData } = this.state;
    const newInsuredData = JSON.parse(JSON.stringify(insuredData));
    const insuredCoverages = newInsuredData[insured].coverages;
    const insuredCoveragesCodes = insuredCoverages.map((cov: Coverage) => cov.code);

    if (coverage.groupName) {
      insuredCoverages.forEach((cov: Coverage, index: number) => {
        if (cov.groupName === coverage.groupName) {
          cov.errorCode = "";
          if (cov.code === coverage.code) {
            newInsuredData[insured].coverages[index].checked = value;
          } else if (value) {
            newInsuredData[insured].coverages[index].checked = !value;
          }
        }
      });
    } else {
      const index = insuredCoveragesCodes.indexOf(coverage.code);
      newInsuredData[insured].coverages[index].checked = value;
    }

    this.setState({ insuredData: newInsuredData, indexInsured: insured });
  };

  handleCapitalChange(capitalValue: string, insuredIndex: number, coverageCode: string) {
    let { insuredData } = this.state;
    insuredData[insuredIndex].coverages.forEach((coverage: Coverage) => {
      if (coverage.code === coverageCode) {
        coverage.capitalValue = capitalValue;
        coverage.errorCode = "";
      }
    });
    this.setState({ insuredData });
  }

  handleInsuredCheck(insuredIndex: number) {
    let { insuredData } = this.state;
    insuredData.forEach((insured: InsuredData, index) => {
      if (index === insuredIndex) {
        insured.checked = !insured.checked;
      }
    });

    this.setState({ insuredData });
  }

  getIsDisabledMainButton = () => {
    const { valid, postalCode, birthDate } = this.state;
    if (!postalCode || !valid.postalCode.validated || !birthDate || !valid.birthDate) {
      return true;
    }
    return false;
  };

  handleImportInsureds = (newInsureds: InsuredData[]) => {
    this.setState({
      birthDate: "",
      insuredData: newInsureds,
      postalCode: "",
      gender: "",
    });
  };

  getCsvData = () => {
    const { insuredData } = this.state;
    const csvData = formatInsuredsCsv(insuredData);
    return csvData;
  };

  render() {
    const { birthDate, gender, insuredData, postalCode, valid, serverError, coverages } =
      this.state;

    const minInsureds = deepGet(this.props.policy, "product.products_minInsureds", 2) || 2;
    const maxInsureds = deepGet(this.props.policy, "product.products_maxInsureds", 50) || 50;

    const hasMaxInsureds = insuredData.length >= Number(maxInsureds);
    const hasMinInsureds = insuredData.length >= Number(minInsureds);

    return (
      <PymesInsuredContainer>
        <div className="data-flow-status">
          <div className="data-flow-status-title">
            <h2>DATOS DEL SEGURO</h2>
          </div>
          <div className="data-flow-status-guide">
            <GuideLine steps={[0, 0, 0, 0]} currentStep={2} />
          </div>
        </div>

        <div className="data-wrapper">
          <div className="content-wrapper bottomMargin40">
            <div className="personal-data-wrapper">
              <div className="data-title">
                <h5>DATOS DE LOS ASEGURADOS</h5>
              </div>
            </div>

            <div className="data-row colSin-100">
              <div className="colSin-33 rightPadding20 topMargin12">
                <PostalCode
                  valid={valid}
                  value={postalCode}
                  disabled={hasMaxInsureds}
                  setLoading={this.props.setLoading}
                  onChange={this.handleOnChangePostalCode}
                />
              </div>

              <div className="colSin-33 rightPadding20 topMargin12">
                <div className="inputBox">
                  <CalendarBox
                    initialValue={birthDate}
                    placeholder="Fecha de nacimiento"
                    forbidFutureDates
                    maxDate={moment().toISOString()}
                    required
                    onChange={(value: string) => {
                      this.handleOnChangeBirthData(value);
                    }}
                    health={true}
                    disabled={hasMaxInsureds}
                    errorCode={valid.birthDate.errorCode}
                  />
                </div>
              </div>

              <div className="colSin-33 rightPadding20">
                <DicotomicButton
                  required={false}
                  labelText="Sexo"
                  options={genderOptions}
                  withTab={true}
                  initialValue={gender}
                  onChange={(value: string) => this.handleOnChangeGender(value)}
                  errorCode={valid.gender.errorCode}
                  disabled={hasMaxInsureds}
                />
              </div>
            </div>

            <div className="buttons">
              <div className="buttons-item">
                <MainButton
                  disabled={this.getIsDisabledMainButton() || hasMaxInsureds}
                  text="Añadir asegurado"
                  onClick={() => this.handleAddInsured()}
                />
              </div>
              <ExportInsuredsButton getCsvData={this.getCsvData} flow={FLOW_AREA.SIMULACION} />
              <ImportButton
                onAddInsureds={this.handleImportInsureds}
                maxInsureds={maxInsureds}
                coverages={coverages}
                validateInsureds={validateSimulationInsureds}
                jsonDataType="simulation"
                flow={FLOW_AREA.CONTRATACION}
              />
            </div>

            {hasMaxInsureds && (
              <p className="text-max-size">{`*El número máximo de asegurados es de ${
                deepGet(this.props.policy, "product.products_maxInsureds", 50) || 50
              }.`}</p>
            )}
            {!hasMinInsureds && (
              <p className="text-max-size">{`*El número mínimo de asegurados es de ${
                deepGet(this.props.policy, "product.products_minInsureds", 2) || 2
              }.`}</p>
            )}
          </div>

          <div className="content-wrapper bottomMargin20">
            <div className="tabs">
              {insuredData.map((insurance, index) => (
                <HealthInsuredItem
                  age={calcAge(getDayMonthYear(insurance.birthDate).toString())}
                  birthDate={insurance.birthDate}
                  checked={insurance.checked}
                  coverages={insurance.coverages}
                  gender={insurance.gender}
                  id={index + 1}
                  index={index}
                  key={index}
                  onChange={(
                    insured: number,
                    age: number = calcAge(getDayMonthYear(insurance.birthDate).toString()),
                    coverage: Coverage,
                    value: boolean
                  ) => this.onChangeOption(insured, age, coverage, value)}
                  onCheckInsured={(insured: number) => this.handleInsuredCheck(insured)}
                  onClick={() => this.handleRemoveInsured(index)}
                  handleCapitalChange={(value: string, coverageCode: string) =>
                    this.handleCapitalChange(value, index, coverageCode)
                  }
                />
              ))}
            </div>
          </div>
        </div>

        <div className="colSin-100 topMargin20 bottomMargin40">
          <div className="personal-data-buttons">
            <div className="personal-data-buttons__item">
              <MainButton
                withTab={true}
                icon={true}
                type={"white"}
                iconImg={images.IconArrowLeftBlue}
                text="Atrás"
                onClick={() => this.props.history.push("/simulacion/nueva/salud-pymes/mediador")}
              />
            </div>
            <div className="personal-data-buttons__item">
              <MainButton
                text="Siguiente"
                disabled={!hasMinInsureds}
                onClick={() => this.toValidate()}
              />
            </div>
          </div>
        </div>
        <ErrorModalContainer className={`${serverError && `active`}`}>
          <div className="recover-modal">
            <div className="server-error">
              <p>{this.state.modalErrorText}</p>
            </div>
            <div className="button-error">
              <MainButton text="Aceptar" onClick={() => this.setState({ serverError: false })} />
            </div>
          </div>
        </ErrorModalContainer>
      </PymesInsuredContainer>
    );
  }
}

export default withGeneral(withPolicy(withCoverages(withRouter(PymesInsured))));
